import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1187 22.0006C7.67998 22.0006 3.59434 19.0508 2.38378 14.6011C1.67762 12.0012 2.0307 9.35141 3.39258 7.00156C4.75446 4.7017 6.92338 3.05181 9.49582 2.35185C12.1187 1.6519 14.792 2.00187 17.1627 3.35179C19.4829 4.70171 21.1475 6.85157 21.8536 9.40141C22.2067 10.7513 22.3076 12.1512 22.0554 13.5512C21.9545 14.1011 21.4501 14.4511 20.8953 14.4011C20.3404 14.3011 19.9873 13.8011 20.0378 13.2512C20.2395 12.1512 20.1891 11.0013 19.8865 9.90138C19.3316 7.85151 18.0202 6.10162 16.1539 5.05168C14.2876 4.00175 12.1187 3.70177 10.0507 4.25173C5.76326 5.40166 3.19082 9.75139 4.35094 14.0511C5.51106 18.3009 9.89934 20.8507 14.2372 19.7008C14.792 19.5508 15.3469 19.9008 15.4477 20.4007C15.5991 20.9507 15.246 21.5007 14.7416 21.6006C13.8337 21.9006 12.9762 22.0006 12.1187 22.0006Z"
      fill="currentColor"
    />
    <path
      d="M2.5 10.1816C1.65 10.1816 1 10.8908 1 11.8181V13.9999C1 14.9272 1.65 15.6364 2.5 15.6364C3.35 15.6364 4 14.9272 4 13.9999V11.8181C4 10.9453 3.35 10.1816 2.5 10.1816ZM21.5 10.1816C20.65 10.1816 20 10.8908 20 11.8181V13.9999C20 14.9272 20.65 15.6364 21.5 15.6364C22.35 15.6364 23 14.9272 23 13.9999V11.8181C23 10.9453 22.35 10.1816 21.5 10.1816Z"
      fill="currentColor"
    />
    <path
      d="M7.52881 11.0917C7.52881 11.7413 7.87824 12.3415 8.44548 12.6663C9.01271 12.9911 9.71157 12.9911 10.2788 12.6663C10.846 12.3415 11.1955 11.7413 11.1955 11.0917C11.1955 10.0875 10.3747 9.27344 9.36214 9.27344C8.34962 9.27344 7.52881 10.0875 7.52881 11.0917Z"
      fill="currentColor"
    />
    <path
      d="M13.0288 11.0917C13.0288 12.0959 13.8496 12.9099 14.8621 12.9099C15.8747 12.9099 16.6955 12.0959 16.6955 11.0917C16.6955 10.0875 15.8747 9.27344 14.8621 9.27344C13.8496 9.27344 13.0288 10.0875 13.0288 11.0917Z"
      fill="currentColor"
    />
  </svg>
);
